/* BG COM · article de blog, piste B « Guide de décision » (17/10/2026, jury 1 intégré).
   Affichage seulement : le texte de l'article n'est jamais modifié. Chargé en defer par sections/bgcom-article.
   Les numéros des liens et le bloc de choix sont posés AVANT ce script (CSS + Liquid) : rien ne saute au chargement.
   1 étapes (scène collante + repères)  2 notes en marge (≥ 1240 px, pas des liens)  3 choix en 1 clic  4 tableau  5 rayons liés
   6 fil des étapes (toutes largeurs)  7 apparition au défilement */
(function(){
  var root = document.querySelector('[data-bgbl-b]');
  if(!root || root.getAttribute('data-b-init')) return; root.setAttribute('data-b-init', '1');
  var rte = root.querySelector('[data-bgbl-rte]'); if(!rte) return;
  var D = {}; try{ D = JSON.parse(document.getElementById('bgbl-b-data').textContent); }catch(e){}
  var P = D.p || {}, C = D.c || {}, A = D.a || {};
  var $$ = function(s, r){ return [].slice.call((r || root).querySelectorAll(s)); };
  function cap(s){ s = String(s || '').replace(/\s+/g, ' ').trim(); return s.charAt(0).toUpperCase() + s.slice(1); }
  function esc(s){ return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  var ICO_GRID = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><rect x="3" y="3" width="7" height="7" rx="1.5"/><rect x="14" y="3" width="7" height="7" rx="1.5"/><rect x="3" y="14" width="7" height="7" rx="1.5"/><rect x="14" y="14" width="7" height="7" rx="1.5"/></svg>';
  var ARR = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
  /* même liste, même ordre que le compteur CSS .bgbl-rte a[…]::after (snippets/bgcom-article-b) */
  /* liens marqués côté serveur (data-k = p / c / g, sections/bgcom-article) ; hors tableaux, figures, grille masquée et titres */
  var LINKS = 'a[data-k]';
  function kind(a){
    var p = a.pathname || '', m;
    if((m = p.match(/\/products\/([^\/?#]+)/))) return ['prod', decodeURIComponent(m[1])];
    if((m = p.match(/^\/collections\/([^\/?#]+)/))) return ['cat', decodeURIComponent(m[1])];
    if((m = p.match(/^\/blogs\/[^\/]+\/([^\/?#]+)/))) return ['art', decodeURIComponent(m[1])];
    return null;
  }
  /* une destination = un numéro (≥ 1240 px le numéro vient de data-n ; en dessous la pastille est une icône de type) */
  var links = $$(LINKS, rte).filter(function(a){ return !a.closest('table, figure, .bg-product-grid, h1, h2, h3, h4'); }), byDest = {}, nd = 0;
  /* classes posées une fois (plus aucun :has() dans la CSS : trop coûteux pendant la lecture de la page) */
  $$('ol', rte).forEach(function(ol){ if(ol.querySelector(':scope > li:first-child > strong:first-child')) ol.classList.add('bgbl-steps'); });
  $$('table', rte).forEach(function(tb){ if(tb.rows[0] && tb.rows[0].cells.length > 2) tb.classList.add('bgbl-t3'); });
  links.forEach(function(a){ var k = kind(a), key = k ? k[0] + ':' + k[1] : a.href; if(!byDest[key]) byDest[key] = { n:++nd, a:a, k:k }; a.setAttribute('data-n', byDest[key].n); });
  var WIDE = window.matchMedia('(min-width: 1240px)').matches;

  /* repères des photos : lettres (A, B…) au lieu de chiffres, qui se confondaient avec les numéros d'étape ; la légende reprend la même pastille */
  var ABC = 'ABCDEFGHIJ';
  $$('.bg-annotated', rte).forEach(function(fig){
    var map = {};
    $$('.bg-mark', fig).forEach(function(mk, i){ var d = mk.textContent.trim(); var L = map[d] || (map[d] = ABC.charAt(Object.keys(map).length)); mk.textContent = L; });
    $$('.bg-annotation-key p', fig).forEach(function(p){
      var st = p.querySelector('strong'); if(!st) return;
      var m = st.textContent.match(/^\s*(\d+)\s*[·.\-:]\s*(.+)$/); if(!m || !map[m[1]]) return;
      st.innerHTML = '<span class="bgbl-lgc" aria-hidden="true">' + map[m[1]] + '</span>' + esc(m[2]);
      p.classList.add('bgbl-lgp');
    });
  });
  /* étape lue = pastille pleine ; étapes passées = fil rempli (toutes largeurs) */
  function stepState(lis, j){ lis.forEach(function(x, i){ x.classList.toggle('is-on', i === j); x.classList.toggle('is-done', i < j); }); }
  /* ---------- 1. étapes : la photo de synthèse reste collée (≥ 990 px), l'étape lue s'allume avec ses repères ---------- */
  var S = D.s || {};
  $$('figure.bg-process-overview', rte).forEach(function(fig){
    var ol = fig.nextElementSibling; if(!ol || ol.tagName !== 'OL') return;
    var lis = [].slice.call(ol.children).filter(function(li){ return li.tagName === 'LI'; });
    if(!window.matchMedia('(min-width: 990px)').matches) return;
    var ph = S.phases || [], np = S.panneaux || 0, names = S.noms || [], cur = 0;
    var sc = document.createElement('div'); sc.className = 'bgbl-sc';
    var stage = document.createElement('div'); stage.className = 'bgbl-sc-stage';
    fig.parentNode.insertBefore(sc, fig);
    stage.appendChild(fig); sc.appendChild(stage); sc.appendChild(ol);
    for(var i = 1; np > 1 && i <= np; i++) fig.insertAdjacentHTML('beforeend', '<span class="bgbl-dim" data-p="' + i + '" style="left:' + ((i - 1) * 100 / np) + '%;width:' + (100 / np) + '%"></span>');
    stage.insertAdjacentHTML('beforeend', '<div class="bgbl-sc-cap"><span>Étape <b data-sc-n>1</b> / ' + lis.length + '</span><span class="bgbl-sc-bar"></span><span data-sc-p></span></div>');
    function on(li){
      var j = lis.indexOf(li); if(j < 0) return; cur = j;
      stepState(lis, j);
      var p = ph[j] || 0;
      stage.querySelector('[data-sc-n]').textContent = j + 1;
      stage.querySelector('[data-sc-p]').textContent = p ? (names[p - 1] || '') : '';
      sc.style.setProperty('--sp', ((j + 1) / lis.length).toFixed(3));
      $$('.bgbl-dim', fig).forEach(function(d){ d.classList.toggle('is-off', !p || +d.getAttribute('data-p') === p); });
      $$('.bgbl-smk', fig).forEach(function(m){ m.classList.toggle('is-on', +m.getAttribute('data-s') === j); });
    }
    /* repères des photos annotées (recadrages Shopify width/height/crop de la même image) reportés sur la photo collante */
    var big = fig.querySelector('img');
    function project(){
      var W = big.naturalWidth, H = big.naturalHeight; if(!W || !H) return;
      lis.forEach(function(li, j){
        $$('.bg-annotation-photo', li).forEach(function(box){
          var im = box.querySelector('img'), u; if(!im) return;
          try{ u = new URL(im.getAttribute('src'), location.href); }catch(e){ return; }
          var cw = +u.searchParams.get('width'), ch = +u.searchParams.get('height'), cr = u.searchParams.get('crop') || 'center';
          if(!cw || !ch) return;
          var a = cw / ch, b = (parseFloat(im.style.width) / parseFloat(im.style.height)) || 140 / 230, rw, rh, x0, y0;
          if(W / H > a){ rh = H; rw = H * a; y0 = 0; x0 = cr === 'left' ? 0 : cr === 'right' ? W - rw : (W - rw) / 2; }
          else { rw = W; rh = W / a; x0 = 0; y0 = cr === 'top' ? 0 : cr === 'bottom' ? H - rh : (H - rh) / 2; }
          $$('.bg-mark', box).forEach(function(mk){
            var mx = parseFloat(mk.style.left) / 100, my = parseFloat(mk.style.top) / 100; if(isNaN(mx) || isNaN(my)) return;
            var cx = mx, cy = my;
            if(a > b) cx = (1 - b / a) / 2 + mx * b / a; else cy = (1 - a / b) / 2 + my * a / b;
            fig.insertAdjacentHTML('beforeend', '<span class="bgbl-smk" data-s="' + j + '" style="left:' + ((x0 + cx * rw) / W * 100).toFixed(2) + '%;top:' + ((y0 + cy * rh) / H * 100).toFixed(2) + '%">' + esc(mk.textContent.trim()) + '</span>');
          });
        });
      });
      on(lis[cur]);
    }
    if(big){ if(big.complete) project(); else big.addEventListener('load', project); }
    on(lis[0]);
    if('IntersectionObserver' in window){
      var io = new IntersectionObserver(function(es){ es.forEach(function(en){ if(en.isIntersecting) on(en.target); }); }, { rootMargin:'-45% 0px -45% 0px' });
      lis.forEach(function(li){ io.observe(li); });
    }
  });

  /* ---------- 2. notes en marge (≥ 1240 px) : une par destination, calée sur le haut de son lien, compacte si la place manque.
     Après le chargement, quand le navigateur est libre ; toutes les lectures de mise en page d'abord, une seule écriture ensuite
     (jury 2 : 19 notes lues/écrites en alternance = une tâche de 500 ms). 10 notes au plus : produits et rayons d'abord. ---------- */
  if(WIDE){
    var COMPACT = 48, MAXN = 10;
    var notes = function(){
      var rr = rte.getBoundingClientRect(), base = rr.top, rteR = rr.right;
      var cand = [];
      Object.keys(byDest).forEach(function(key){
        var d = byDest[key], blk = d.k && d.a.closest('p, li'); if(!blk) return;
        if(Math.abs(blk.getBoundingClientRect().right - rteR) > 2) return; /* bloc plus étroit ou décalé (étapes, photos) : pas de note */
        cand.push(d);
      });
      var keep = cand.filter(function(d){ return d.k[0] !== 'art'; }).concat(cand.filter(function(d){ return d.k[0] === 'art'; })).slice(0, MAXN);
      cand = cand.filter(function(d){ return keep.indexOf(d) > -1; });
      if(!cand.length) return;
      var col = document.createElement('div'); col.className = 'bgbl-snc'; col.setAttribute('aria-hidden', 'true');
      cand.forEach(function(d){
        var a = d.a, k = d.k, n = d.n, h = k[1], txt = a.textContent.replace(/\s+/g, ' ').trim(), inner;
        if(k[0] === 'prod'){
          var pr = P[h] || {};
          inner = '<span class="t">' + (pr.i ? '<img src="' + esc(pr.i) + '" alt="" width="120" height="120" loading="lazy">' : ICO_GRID) + '</span><span class="x"><small><i>' + n + '</i>Produit</small><b>' + esc(pr.t || txt) + '</b><em>Voir la fiche ' + ARR + '</em></span>';
        } else if(k[0] === 'cat'){
          inner = '<span class="t dk">' + ICO_GRID + '</span><span class="x"><small><i>' + n + '</i>Rayon</small><b>' + esc(cap(txt) || C[h]) + '</b><em>Voir tout le rayon ' + ARR + '</em></span>';
        } else {
          var ar = A[h] || {};
          inner = '<span class="t' + (ar.i ? '' : ' dk') + '">' + (ar.i ? '<img class="cv" src="' + esc(ar.i) + '" alt="" width="120" height="120" loading="lazy">' : '<i class="sl">//</i>') + '</span><span class="x"><small><i>' + n + '</i>Guide lié</small><b>' + esc(ar.t || txt) + '</b><em>' + (ar.m ? ar.m + ' min de lecture' : 'Lire le guide') + '</em></span>';
        }
        /* pas un lien : le texte garde seul le lien (pas de doublon pour Google ni pour le lecteur d'écran) ; la position va sur l'enveloppe */
        var w = document.createElement('div'); w.className = 'bgbl-snw';
        w.innerHTML = '<div class="bgbl-sn is-' + k[0] + '" data-for="' + n + '">' + inner + '</div>';
        w.firstChild.addEventListener('click', function(){ a.click(); });
        col.appendChild(w); d.w = w; d.el = w.firstChild;
      });
      rte.appendChild(col);
      cand.forEach(function(d){ d.h = d.el.offsetHeight; }); /* une seule mise en page, puis lectures sans écriture */
      var h2 = $$('h2', rte);
      var lay = function(){
        var b0 = rte.getBoundingClientRect().top, ht = h2.map(function(x){ return x.getBoundingClientRect().top - b0; }), y = -1e9;
        cand.forEach(function(d){ d.want = d.a.getBoundingClientRect().top - b0 - 8; });
        cand.forEach(function(d){
          var lim = Infinity; for(var i = 0; i < ht.length; i++){ if(ht[i] > d.want + 1){ lim = ht[i]; break; } }
          var top = Math.max(d.want, y + 12), h = d.h; d.c = false;
          if(top - d.want > 64 || top + h > lim - 8){ d.c = true; h = COMPACT; }
          d.top = top; y = top + h;
        });
        cand.forEach(function(d){ d.w.style.top = Math.round(d.top) + 'px'; d.el.classList.toggle('is-compact', d.c); });
      };
      lay();
      var rq = 0, req = function(){ if(!rq) rq = requestAnimationFrame(function(){ rq = 0; lay(); }); };
      if('ResizeObserver' in window) new ResizeObserver(req).observe(rte); else window.addEventListener('resize', req);
    };
    var idle = window.requestIdleCallback ? function(f){ requestIdleCallback(f, { timeout:2000 }); } : function(f){ setTimeout(f, 200); };
    if(document.readyState === 'complete') idle(notes); else window.addEventListener('load', function(){ idle(notes); });
  }
  /* survol lié : le lien et sa note s'allument ensemble */
  var lit = [];
  rte.addEventListener('mouseover', function(e){
    var t = e.target.closest('a[data-n], .bgbl-sn'), id = t && (t.getAttribute('data-n') || t.getAttribute('data-for'));
    lit.forEach(function(x){ x.classList.remove('is-lit'); }); lit = [];
    if(!id) return;
    lit = $$('a[data-n="' + id + '"], .bgbl-sn[data-for="' + id + '"]', rte);
    lit.forEach(function(x){ x.classList.add('is-lit'); });
  });

  /* ---------- 3. choix en 1 clic (rendu en Liquid depuis le métachamp bgcom.decision) ---------- */
  var dec = root.querySelector('[data-bgbl-dec]'), keys = [];
  function choose(key, focus){
    root.setAttribute('data-ch', key);
    var hp = '';
    $$('[data-dec-opt]', dec).forEach(function(b){
      var on = b.getAttribute('data-dec-opt') === key;
      b.setAttribute('aria-checked', on ? 'true' : 'false'); b.tabIndex = on ? 0 : -1;
      if(on){ hp = b.getAttribute('data-dec-h') || ''; if(focus) b.focus(); }
    });
    $$('[data-dec-out]', dec).forEach(function(v){ v.hidden = v.getAttribute('data-dec-out') !== key; });
    dec.classList.add('is-set');
    $$('[data-ch-col]', rte).forEach(function(c){ c.classList.toggle('is-ch', c.getAttribute('data-ch-col') === key); });
    $$('table', rte).forEach(function(tb){ tb.classList.toggle('has-ch', !!tb.querySelector('[data-ch-col]')); });
    $$('.bgbl-pt').forEach(function(t){ t.classList.toggle('is-ch', !!hp && (t.getAttribute('href') || '').indexOf('/products/' + hp) > -1); });
    try{ if(window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('bgcom_article_choice', { choice:key, product:hp, article:location.pathname }); }catch(e){}
  }
  if(dec){
    var opts = $$('[data-dec-opt]', dec);
    keys = opts.map(function(b){ return b.getAttribute('data-dec-opt'); });
    opts.forEach(function(b){ b.addEventListener('click', function(){ choose(b.getAttribute('data-dec-opt')); }); });
    dec.querySelector('[role=radiogroup]').addEventListener('keydown', function(e){
      if(!/^Arrow/.test(e.key)) return;
      var i = opts.indexOf(document.activeElement), j = (i + (/Right|Down/.test(e.key) ? 1 : opts.length - 1)) % opts.length;
      choose(opts[j].getAttribute('data-dec-opt'), true); e.preventDefault();
    });
  }

  /* ---------- 4. tableau : colonnes des options, vignettes en tête (place réservée en CSS), ligne « Produits » en boutons ---------- */
  $$('table', rte).forEach(function(tb){
    var head = tb.rows[0], last = tb.rows[tb.rows.length - 1]; if(!head || head === last) return;
    if(keys.length) [].forEach.call(head.cells, function(cell, ci){
      var label = cell.textContent.replace(/\s+/g, ' ').trim().toUpperCase();
      var key = keys.filter(function(k){ k = String(k).toUpperCase(); return label === k || label.indexOf(k + ' ') === 0; })[0];
      if(!key) return;
      [].forEach.call(tb.rows, function(r){ if(r.cells[ci]) r.cells[ci].setAttribute('data-ch-col', key); });
      var op = (D.o || []).filter(function(o){ return o.key === key; })[0];
      if(op && op.tete) cell.insertAdjacentHTML('beforeend', '<small class="bgbl-tete">' + esc(op.tete) + '</small>');
    });
    var pl = [].map.call(last.cells, function(c){ return c.querySelector('a[href*="/products/"]'); });
    if(pl.filter(Boolean).length < 2) return;
    tb.classList.add('bgbl-duel'); last.classList.add('bgbl-prow');
    pl.forEach(function(a, ci){
      if(!a) return; a.classList.add('bgbl-btn'); a.insertAdjacentHTML('beforeend', ARR);
      var k = kind(a), pr = k && P[k[1]], hc = head.cells[ci];
      if(pr && pr.i && hc) hc.insertAdjacentHTML('afterbegin', '<span class="bgbl-th" aria-hidden="true"><img src="' + esc(pr.i) + '" alt="" width="120" height="120" loading="lazy"></span>');
    });
  });

  /* ---------- 5. rayons liés sous l'étagère (bas de page : hors écran au chargement) ---------- */
  var seen = {}, chips = '';
  links.forEach(function(a){ var k = kind(a); if(!k || k[0] !== 'cat' || seen[k[1]]) return; seen[k[1]] = 1; chips += '<a class="bgbl-chip" href="' + esc(a.getAttribute('href')) + '">' + esc(cap(a.textContent) || C[k[1]]) + '<span>' + ARR + '</span></a>'; });
  var shelf = root.querySelector('.bgbl-ptiles');
  if(chips && shelf) shelf.insertAdjacentHTML('afterend', '<div class="bgbl-chips"><span>Rayon lié</span>' + chips + '</div>');
  /* ---------- 6. étapes, toutes largeurs : fil qui se remplit au défilement + nom de la phase en tête de chaque groupe ---------- */
  $$('ol', rte).forEach(function(ol){
    if(!ol.querySelector(':scope > li:first-child > strong:first-child')) return;
    var lis = [].slice.call(ol.children).filter(function(li){ return li.tagName === 'LI'; }); if(lis.length < 2) return;
    var proc = ol.closest('.bgbl-sc') || (ol.previousElementSibling && ol.previousElementSibling.matches('figure.bg-process-overview'));
    if(proc && S.phases && S.noms) lis.forEach(function(li, j){
      var p = S.phases[j]; if(!p || p === S.phases[j - 1]) return;
      var t = li.querySelector(':scope > strong:first-child'); if(t) t.setAttribute('data-phase', (p < 10 ? '0' : '') + p + ' · ' + (S.noms[p - 1] || '')); /* sur le titre : il reste le 1er enfant */
    });
    if(ol.closest('.bgbl-sc')) return; /* la scène collante gère déjà l'étape lue */
    stepState(lis, -1);
    if('IntersectionObserver' in window){
      var io2 = new IntersectionObserver(function(es){ es.forEach(function(en){ if(en.isIntersecting) stepState(lis, lis.indexOf(en.target)); }); }, { rootMargin:'-45% 0px -45% 0px' });
      lis.forEach(function(li){ io2.observe(li); });
    }
  });

  /* ---------- 7. apparition au défilement : une fois, seulement ce qui est sous l'écran au chargement (rien ne clignote, rien ne bouge la mise en page) ---------- */
  if('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches){
    var WORDS = window.matchMedia('(min-width: 750px)').matches;
    var rv = $$((WORDS ? '' : '.bgbl-rte h2, ') + '.bgbl-rte table, .bgbl-rte figure.bg-process-overview, .bgbl-rte .bgbl-pline, .bgbl-rte .bg-product-inline, .bgbl-rte ol > li, .bgbl-ptiles > *, .bgbl-chips, .bgbl-dec');
    var vh = window.innerHeight, below = rv.filter(function(el){ return el.getBoundingClientRect().top > vh; });
    var io3 = new IntersectionObserver(function(es){
      es.forEach(function(en){
        if(!en.isIntersecting) return; var el = en.target; io3.unobserve(el);
        el.classList.add('is-in');
        if(!el.classList.contains('bgbl-wr')) setTimeout(function(){ el.classList.remove('bgbl-rv', 'is-in'); el.style.removeProperty('--d'); }, 1100); /* rend ses propres transitions (survols) à l'élément */
      });
    }, { rootMargin:'0px 0px -8% 0px' });
    /* titres : mot à mot, flou qui se dissipe (même geste que les titres de l'accueil) */
    if(WORDS) $$('h2', rte).forEach(function(h){
      if(h.getBoundingClientRect().top <= vh) return;
      var i = 0, walk = function(node){
        [].slice.call(node.childNodes).forEach(function(c){
          if(c.nodeType === 3){
            var parts = c.textContent.split(/(\s+)/), f = document.createDocumentFragment();
            parts.forEach(function(t){ if(!t) return; if(/^\s+$/.test(t)){ f.appendChild(document.createTextNode(t)); return; } var sp = document.createElement('span'); sp.className = 'bgbl-w'; sp.style.setProperty('--i', i++); sp.textContent = t; f.appendChild(sp); });
            c.parentNode.replaceChild(f, c);
          } else if(c.nodeType === 1 && !c.classList.contains('bgbl-anc')) walk(c);
        });
      };
      walk(h); h.classList.add('bgbl-wr'); io3.observe(h);
    });
    below.forEach(function(el){
      var sib = el.parentNode ? [].indexOf.call(el.parentNode.children, el) : 0;
      if(/^(LI)$/.test(el.tagName) || el.parentNode.classList.contains('bgbl-ptiles')) el.style.setProperty('--d', (sib % 4) * 70 + 'ms');
      el.classList.add('bgbl-rv'); io3.observe(el);
    });
  }
})();
